import React, { useEffect, useState } from 'react';
import WithNavigation from '../../layouts/WithNavigation';
import Table, { Hidden } from '../../components/Table';
import Empty from '../../components/Empty';
import Button from '../../components/Button';
import { Link } from 'react-router-dom';
import Icon from '../../components/Icon';
import { useSelector, useDispatch } from 'react-redux';
import { fetchMainServiceRequestPDFDownloadList } from '../../store/actions/csvExport';
import { toast } from 'react-toastify';
import {
  serviceRequestTableLocalTime,
  ToastInfo,
} from '../../helpers/validationHelper';
import Loader from '../../components/Loader';
import { SuccessMessages } from '../../common/constants';

import EditPdfName from './EditPdfName';
import * as client from '../../services/client';

import download from 'downloadjs';

const Request = () => {
  const [showOverlay, setShowOverLay] = useState(false);
  const [pdfdata, setpdfdata] = useState('');

  const dispatch = useDispatch();
  const auth = useSelector((state) => state.auth);
  const userID = auth && auth.user && auth.user.id;
  const csvExport = useSelector((state) => state.csvExport);
  const serviceRequestPDFDownloadList =
    (csvExport && csvExport.serviceRequestPDFDownloadList) || [];
  const csvExportLoading = csvExport && csvExport.loading;

  useEffect(() => {
    dispatch(fetchMainServiceRequestPDFDownloadList(userID));
  }, []);

  const editPdfname = (e, pdfdata) => {
    setpdfdata(pdfdata);
    setShowOverLay(true);
  };

  const handlepopup = (value) => {
    setShowOverLay(value);
  };

  const exportPDF = (pdfurl) => {
    if (pdfurl !== null) {
      ToastInfo(SuccessMessages.pdfDownloadNotification);
      // For downloading PDF we are using download function here.
      download(pdfurl);
    } else {
      toast.error(
        ' 🚫 PDF preparation is still in progress, please try again after some time.',
        { autoClose: 12000, position: 'top-center' }
      );
    }
  };

  const onDeletePDFfile = async (unitId) => {
    const user = JSON.parse(localStorage.getItem('user'));
    await onDeletePDF(unitId, user.id);
  };
  const onDeletePDF = async (unitId, userId) => {
    const response = await client.DeleteUserPDFRequest(userId, unitId);
    if (response.ok || response.status === 200) {
      response.json().then((responsejson) => {
        if (responsejson.statusCode === 200) {
          toast.success(' ⓘ PDF has been deleted.', {
            autoClose: 10000,
            position: 'top-center',
          });
          dispatch(fetchMainServiceRequestPDFDownloadList(userID));
        } else {
          toast.error(
            'Sorry, cannot delete PDF at this time. Please try again later.',
            {
              autoClose: 5000,
              position: 'top-center',
            }
          );
        }
      });
    } else {
    }
  };

  return (
    <WithNavigation
      title="Request"
      hide={true}
      border
      top={
        <div style={{ padding: '50px' }}>
          {csvExportLoading === true ? (
            <Loader center={true} />
          ) : serviceRequestPDFDownloadList.length > 0 ? (
            <>
              <h1 className="headingMobile">Download PDF Requests</h1>
              <Table
                columns={[
                  {
                    label: 'File Name',
                    accessor: 'fileName',
                    cell: (data) => data.fileName,
                    style: { width: '40%' },
                  },
                  {
                    label: 'Requested By',
                    accessor: 'requestedName',
                    cell: (data) => data.requestedName,
                  },
                  {
                    label: 'Requested Date',
                    accessor: 'requestedDate',
                    cell: (data) =>
                      serviceRequestTableLocalTime(data.requestedDate),
                  },
                  {
                    label: 'Action',
                    accessor: 'pdfurl',
                    cell: (data) =>
                      data.pdfurl !== null ? (
                        <>
                          <Button
                            color="semantic"
                            label={<Icon glyph="download" weight="light" />}
                            onClick={() => exportPDF(data.pdfurl)}
                          />
                          <span
                            style={{ marginLeft: '10px', cursor: 'pointer' }}
                            onClick={(e) => editPdfname(e, data)}
                          >
                            <Icon glyph="pencil" weight="light" />
                          </span>
                          <span
                            style={{ marginLeft: '10px', cursor: 'pointer' }}
                            onClick={() =>
                              window.confirm(
                                `Are you sure you want to delete ${data.fileName !== null ? data.fileName : ''}?`
                              ) && onDeletePDFfile(data.id)
                            }
                          >
                            <Icon glyph="trash" weight="light" />
                          </span>
                        </>
                      ) : (
                        <>
                          <span style={{ marginRight: '10px' }}> N/A </span>
                          <span
                            style={{ marginRight: '10px', cursor: 'pointer' }}
                            onClick={(e) => editPdfname(e, data)}
                          >
                            <Icon glyph="pencil" weight="light" />
                          </span>
                          <span
                            style={{ cursor: 'pointer' }}
                            onClick={() =>
                              window.confirm(
                                `Are you sure you want to delete ${data.fileName !== null ? data.fileName : ''}?`
                              ) && onDeletePDFfile(data.id)
                            }
                          >
                            <Icon glyph="trash" weight="light" />
                          </span>
                        </>
                      ),
                  },
                ]}
                data={serviceRequestPDFDownloadList}
              />
            </>
          ) : (
            <Empty
              direction="ttb"
              headline="No Request yet"
              strapline="All download request which you have requested will be listed here so it’s easier for you to download it later."
              image={
                <img
                  alt="No Announcements yet"
                  src="/assets/empty/properties.svg"
                />
              }
            />
          )}

          {showOverlay && (
            <EditPdfName pdfdata={pdfdata} handlepopup={handlepopup} />
          )}
        </div>
      }
    />
  );
};

export default Request;
